import {
    action,
    computed,
    makeObservable,
    observable,
    runInAction,
} from 'mobx';

import { LoadStateStore } from 'app/loading/LoadStateStore';
import { CardOrder } from 'app/model/CardOrder';
import { CardProduct } from 'app/model/product/CardProduct';
import { OrderService } from 'app/service/OrderService';
import { ProductService } from 'app/service/ProductService';

export class ContinueDraftByLinkPageStore {
    readonly loadStateStore = new LoadStateStore();

    readonly actionStateStore = new LoadStateStore(true);

    private readonly productService = new ProductService();

    private readonly orderService = new OrderService();

    @observable
    private _orderToContinue: CardOrder;

    @observable
    private _cardProduct: CardProduct;

    constructor() {
        makeObservable(this);
    }

    /**
     * Инициализация страницы продолжения черновика по ссылке
     * @param orderId id заявки, которую продолжает пользователь
     * @param channel канал привлечения
     */
    @action
    async initialize({
        orderId,
        channel,
    }: {
        orderId: string;
        channel: string;
    }) {
        return this.loadStateStore.loadData(async () => {
            const order: CardOrder = await this.orderService.getById(orderId);

            if (!order) {
                this.setCardProduct(null);
                this.setOrderToContinue(null);

                return;
            }

            const [cardProduct, personalizedOrder] = await Promise.all([
                this.productService.getCardProduct(
                    order.cardProductCode,
                    channel,
                ),
                this.orderService.personalize(order),
            ]);

            runInAction(() => {
                this.setCardProduct(cardProduct);
                this.setOrderToContinue(personalizedOrder);
            });
        });
    }

    @action
    setOrderToContinue(order: CardOrder) {
        this._orderToContinue = order;
    }

    @computed
    get orderToContinue(): CardOrder {
        return this._orderToContinue;
    }

    @action
    setCardProduct(product: CardProduct) {
        this._cardProduct = product;
    }

    @computed
    get cardProduct(): CardProduct {
        return this._cardProduct;
    }
}
